import React from "react";

const SimpleMessage = ({ children }) => (
  <div className="simple-message">
    <div className="simple-message-content">{children}</div>
  </div>
);

export default SimpleMessage;
